import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import userPopMixin from "@/views/system/index/mixin/userPopMixin";
export default {
  mixins: [userPopMixin],
  name: "complaint-feedback",
  data: function data() {
    return {
      searchForm: {
        pn: 1,
        ps: 20,
        adminId: "",
        id: this.$route.query.id,
        status: ""
      },
      // 搜索表单
      adminList: [],
      tableLoading: false,
      tableData: [],
      // 表格数据
      total: 0
    };
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _this.getData();
            _this.getAdminList();
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  methods: {
    remark: function remark(row) {
      var _this2 = this;
      this.$prompt("", "备注", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        inputValue: row.remark,
        inputPattern: /\S/,
        inputErrorMessage: "请输入备注"
      }).then(function (_ref) {
        var value = _ref.value;
        _this2.$api.setFeedbackRemark({
          id: row.id,
          remark: value
        }).then(function (res) {
          _this2.$message({
            type: "success",
            message: "备注成功"
          });
          _this2.getData();
        });
      }).catch(function () {});
    },
    pageChange: function pageChange(pn) {
      this.searchForm.pn = pn;
      this.getData();
    },
    getData: function getData(type) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              if (type === "search") {
                _this3.searchForm.pn = 1;
              }
              _this3.tableLoading = true;
              _context2.n = 1;
              return _this3.$api.getFeedbackList(_this3.searchForm);
            case 1:
              res = _context2.v;
              _this3.tableData = res.data.list;
              _this3.total = res.data.count;
              _this3.tableLoading = false;
              _this3.getUserListByIds(_this3.tableData, "userId");
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    getAdminList: function getAdminList() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var res;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return _this4.$api.getAdminUser({
                type: "all"
              });
            case 1:
              res = _context3.v;
              _this4.adminList = res.data;
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    setFeedbackStatus: function setFeedbackStatus(id, status, userId) {
      var _this5 = this;
      this.$confirm("是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return _this5.$api.setFeedbackStatus({
                id: id,
                status: status
              });
            case 1:
              _this5.$message.success("操作成功");
              _this5.getData();

              // 操作上报
              _this5.$operationLog.push({
                code: status == 1 ? "shelve" : "resolved",
                userId: userId,
                operationType: "feedback",
                detailBatchNo: id
              });
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }))).catch(function () {});
    }
  }
};